import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type CodeProps = {
  inline?: boolean
  children: React.ReactNode
}

const Code: React.FC<CodeProps> = ({ inline, children }) => {
  const classes = useStyles()

  return (
    <span
      className={clsx(
        classes.root,
        inline ? classes.inlineBlock : classes.multilineBlock
      )}
    >
      {children}
    </span>
  )
}

export default Code
